// @flow
import React, { useState } from 'react'
import { KeyboardDatePicker as DatePickerMui } from '@material-ui/pickers'

import CustomLabel from './CustomLabel'

import makeStyles from '@material-ui/styles/makeStyles'
import { ArrowDropDown, Clear, Done } from '@material-ui/icons'
import { FormHelperText } from '@material-ui/core'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    margin: '1.7vh 0 0 0',
  },
  input: {
    marginTop: 1,
  },
  formHelperText: {
    color: '#FF3755',
    fontSize: '9px',
    /* accessibilité : permet de zoomer les messages d'erreur UI car petite taille en maquette */
    '&:active': {
      transform: 'scale(1.5)',
      margin: '0 auto',
    },
  },
})

//@FIXME: flow value date
type Props = {
  valueDate: any,
  onChangeDate: Function,
  birthdayMode?: boolean,
  clearable?: boolean,
  valueInput?: any,
  label?: string,
  testId?: string,
  inputError?: boolean,
  inputValid?: boolean,
  errorDescription?: string,
}

function DatePicker({
  valueDate = '',
  label = '',
  onChangeDate = (noop) => noop,
  birthdayMode = false,
  clearable = false,
  testId = 'TextInputTester',
  inputError = false,
  inputValid = false,
  errorDescription = '',
  ...props
}: Props) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      {!!label && <CustomLabel>{label}</CustomLabel>}

      <div className={classes.input}>
        <DatePickerMui
          keyboardIcon={
            inputValid || inputError ? (
              !!inputError ? (
                <Clear style={{ color: '#FF3755' }} />
              ) : (
                <Done style={{ color: '#51b03a' }} />
              )
            ) : (
              <ArrowDropDown />
            )
          }
          clearable={clearable}
          style={{ width: '100%' }}
          value={valueDate}
          onChange={onChangeDate}
          openTo={!!birthdayMode ? 'year' : 'date'}
          format="DD/MM/YYYY"
          data-testid={testId}
          invalidDateMessage={''}
          mask={'__/__/____'}
          maxDateMessage={'Vous ne pouvez pas dépasser la date maximale'}
          minDateMessage={'Vous ne pouvez pas dépasser la date minimale'}
          KeyboardButtonProps={{ style: { padding: 0 } }}
          cancelLabel="Annuler"
          {...props}
        />
      </div>
      {!!inputError && !!errorDescription && (
        <FormHelperText className={classes.formHelperText}>{errorDescription}</FormHelperText>
      )}
    </div>
  )
}

export default DatePicker
